module.exports = __webpack_public_path__ + "img/avatar0.2046b961.png";